<template>
  <div id="app">
    <Preloader />
    <component v-if="!$route.path.includes('/mobile')" :is="layout" id="main__app">
      <router-view />
      <LoginPopup v-if="authInfo && authInfo.email === emailPublic" />
      <poppuRequiedLoginSSO v-if="authInfo && authInfo.email === emailPublic" />
      <ModalRegister v-if="authInfo && authInfo.email === emailPublic" />
      <ModalGuideActiveCode />
      <ActiveBook2 v-if="ebookStoreKey in $store._modules.root._children" />
      <ModalActiveBook v-if="ebookStoreKey in $store._modules.root._children" />
    </component>
    <template v-else-if="$route.path.includes('/mobile')">
      <component v-if="$route.query.token" :is="layout" id="main__app">
        <router-view />
      </component>
      <p v-else class="text-center">Dữ liệu đang được cập nhật!</p>
    </template>
    <loading :active.sync="loading" :is-full-page="true" color="#0f3dba" />
  </div>
</template>

<script>
const defaultLayout = "default";
import { mapState, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { EMAIL_PUBLIC } from "@/store/auth/constants";
import { getAuth } from "@/utils/jwt";
import { STORE_KEY as STORE_KEY_EBOOKS } from '@/modules/ebooks/_store/constants'
// import { APP_CONFIG } from '@/utils/constants'
import Preloader from '@/components/Preloader.vue'

export default {
  data () {
    return {
      emailPublic: EMAIL_PUBLIC,
      authInfo: {},
      ebookStoreKey: STORE_KEY_EBOOKS
    }
  },
  components: {
    Preloader,
    Loading,
    LoginPopup: () => import("@/views/auth/LoginPopup.vue"),
    poppuRequiedLoginSSO: () => import("@/views/auth/poppuRequiedLoginSSO.vue"),
    ModalRegister: () => import("@/views/auth/ModalRegister.vue"),
    ModalGuideActiveCode: () => import("@/views/pages/ModalGuideActiveCode.vue"),
    ModalActiveBook: () => import("@/modules/ebooks/_components/common/ModalActiveBook.vue"),
    ActiveBook2: () => import("@/modules/ebooks/_components/common/ActiveBook2.vue"),
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
    ...mapGetters({
      loading: "common/loading",
    }),
    ...mapState("auth", ["loginPopupData"]),
    ...mapState('common', ['mediaShareInfo'])
  },
  watch: {
    $route: "checkAuth"
  },
  mounted() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      this.authInfo = getAuth();
    },
  },
};
</script>

<style lang="scss">
  .wrs_modal_dialogContainer.wrs_modal_desktop.wrs_stack {
    top: 13vh !important;
    bottom: auto !important;
    margin: 0 auto;
    right: 0 !important;
    left: 0 !important;
  }
  #main_app {
    min-height: calc(100vh - 240px);
  }
</style>